// extracted by mini-css-extract-plugin
export var BackPath = "index-module--BackPath--d5102";
export var BigDesktopHeader = "index-module--BigDesktopHeader--71312";
export var BrandLink = "index-module--BrandLink--ae31c";
export var CenteredLogoWrapper = "index-module--CenteredLogoWrapper--6f6c2";
export var CloseButton = "index-module--CloseButton--40efa";
export var ExtraHeader = "index-module--ExtraHeader--fbead";
export var GatsbyImageOuterWrapper = "index-module--GatsbyImageOuterWrapper--37944";
export var Header = "index-module--Header--6f871";
export var HeaderLine = "index-module--HeaderLine--d0e9d";
export var HeaderRightSide = "index-module--HeaderRightSide--6af42";
export var HeaderTitle = "index-module--HeaderTitle--42167";
export var HeaderTitleWrapper = "index-module--HeaderTitleWrapper--0f603";
export var HideOnDesktop = "index-module--HideOnDesktop--b1573";
export var HideOnMobile = "index-module--HideOnMobile--766f1";
export var Logo = "index-module--Logo--9ea58";
export var Narrow = "index-module--Narrow--cf17f";
export var NoShadow = "index-module--NoShadow--d597d";
export var NonMobileBackButtonText = "index-module--NonMobileBackButtonText--1950d";
export var PanelOpen = "index-module--PanelOpen--02dc2";
export var RTL = "index-module--RTL--be226";
export var RelativePosition = "index-module--RelativePosition--80fa9";